import { TFunction } from 'i18next';
import * as Yup from 'yup';

const isEmpty = (v: any) => v === '' || v == null;

export const CustomerFormValidationSchema = (t: TFunction) =>
  Yup.object({
    customerInfo: Yup.object({
      register_store_id: Yup.string().optional(),
      entity_type: Yup.string().required(t('valid_err_required')),
      accountNumber: Yup.string().optional(),
      first_name: Yup.string().required(t('valid_err_required')),
      cardId: Yup.string().optional(),
      branchCode: Yup.string().optional(),
      address_2: Yup.string().optional(),
      birthDate: Yup.string().optional(),
      gender: Yup.string().optional(),
      comments: Yup.string().optional(),
    }),

    customerAddress: Yup.object({
      province_id: Yup.string().nullable(),

      district_id: Yup.string()
        .nullable()
        .when('province_id', {
          is: isEmpty,
          then: (s) => s.notRequired(),
          otherwise: (s) => s.required(t('valid_err_required')),
        }),

      sub_district_id: Yup.string()
        .nullable()
        .when('province_id', {
          is: isEmpty,
          then: (s) => s.notRequired(),
          otherwise: (s) => s.required(t('valid_err_required')),
        }),

      zip: Yup.string()
        .nullable()
        .when('province_id', {
          is: isEmpty,
          then: (s) => s.notRequired(),
          otherwise: (s) => s.required(t('valid_err_required')),
        }),
      city: Yup.string().optional(),
      state: Yup.string().optional(),
      isNewAddress: Yup.boolean().optional(),
      address_1: Yup.string().optional(),
      shippingAddress: Yup.string().optional(),
    }),

    customerContact: Yup.object({
      last_name: Yup.string().optional(),
      phoneNumber: Yup.string().optional(),
      email: Yup.string().email(t('Invalid email')).optional(),
      facebook: Yup.string().optional(),
      line: Yup.string().optional(),
      instagram: Yup.string().optional(),
    }),

    customerFinancialInfo: Yup.object({
      groupPrice: Yup.string().optional(),
      isTaxable: Yup.boolean().optional(),
    }),

    customerCreditInfo: Yup.object({
      dateLimit: Yup.string().optional(),
      receivableLimit: Yup.string().optional(),
    }),
    pickupAddresses: Yup.array().of(
      Yup.object().shape({
        pickupName: Yup.string().required(t('valid_err_required')),
        phone: Yup.string().required(t('valid_err_required')),
        address: Yup.string(),
        state: Yup.string(),
        district: Yup.string(),
        city: Yup.string(),
        zip: Yup.string(),
      })
    ),
  });
export type CustomerValidationSchemaType = ReturnType<
  typeof CustomerFormValidationSchema
>;
